import { render } from "./VideoComponent.vue?vue&type=template&id=14272383&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=14272383&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14272383"]])

export default __exports__